import api from "../../Api/apiAxios";

export async function listarIntegracaoBma(periodo) {
    const resp = await api.get(`/Integracao/bma?periodo=${periodo}`);
    const itens = Array.isArray(resp.data) ? resp.data : [];
    return itens.map((item) => ({ ...item, id: item.clienteId }));
}

export async function listarIntegracaoCanais(periodo) {
    const resp = await api.get(`/Integracao/canais?periodo=${periodo}`);
    const itens = Array.isArray(resp.data) ? resp.data : [];
    return itens.map((item) => ({ ...item, id: item.distribuidorId }));
}

export async function listarClientesCanalServico(distribuidorId, tipoServicoId, periodo) {
    const sufixoTipoServico = tipoServicoId != null ? `&tipoServicoId=${tipoServicoId}` : "";
    const resp = await api.get(`/Integracao/canais/${distribuidorId}/servico?periodo=${periodo}${sufixoTipoServico}`);
    return Array.isArray(resp.data) ? resp.data : [];
}

export async function listarInconsistencias(periodo, aba) {
    const sufixoAba = aba ? `&aba=${aba}` : "";
    const resp = await api.get(`/Integracao/inconsistencias?periodo=${periodo}${sufixoAba}`);
    return Array.isArray(resp.data) ? resp.data : [];
}

export async function obterSituacaoPeriodo(periodo) {
    const resp = await api.get(`/Integracao/periodo/${periodo}/situacao`);
    return resp.data;
}

export async function atualizarCodigoIntegracao(faturamentoId, corpo) {
    const resp = await api.put(`/Integracao/faturamento/${faturamentoId}/codigo-integracao`, corpo);
    return resp.data;
}

export async function gerarIntegracao(corpo) {
    const resp = await api.post('/Integracao/gerar', corpo);
    return resp.data;
}

export async function atualizarStatusOS(osId, novoStatus, usuario) {
    const resp = await api.put(`/Integracao/os/${osId}/status`, { novoStatus, usuario });
    return resp.data;
}

export async function listarHistoricoOS(osId) {
    const resp = await api.get(`/Integracao/os/${osId}/historico`);
    return Array.isArray(resp.data) ? resp.data : [];
}

export async function listarTiposServico() {
    const resp = await api.get('/TipoServico/');
    return Array.isArray(resp.data) ? resp.data : [];
}
